<button type="button" class="light-dark-toggle inline-block leading-none text-primary-500 transition-all" (click)="toggleTheme()">
    <i class="material-symbols-outlined !text-[20px] md:!text-[22px]">
        light_mode
    </i>
</button>
